import { CommentsPanel } from "../components/CommentsPanel.js";

/**
 * The homepage is the community column. Games live in the navbar; surveys sit in
 * the shell sidebar; auth sits in the shell header.
 */
export function HubPage() {
  return <CommentsPanel />;
}
